<template>
  <div id="app" :class="{ 'page-home': pageHome }">
    <navigation></navigation>         
    <router-view/>
    <the-footer></the-footer>
  </div>
</template>

<script>
  import Navigation from '@/components/Navigation'
  import TheFooter from '@/components/TheFooter'
  
  export default {
  name: 'app',
  components: {
    Navigation,
    TheFooter
  },
  data () {
    return {
      pageHome: true,
      sticky: true
    }
  },
  watch: {
    // eslint-disable-next-line
    $route (to, from) {
      //console.log('$route to:', to.name)

      if (to.name === 'home') {
        this.pageHome = true
      } else {
        this.pageHome = false
      }
    }
  }
}

</script>

<style lang="less">
@import '~./less/variables.less';
@import '~./less/global.less';

html, body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Quicksand', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;

  &:after{
    content: '';
    background: url('assets/site-bg.jpg') no-repeat;
    background-size: cover;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;      
  }

  &.page-home{
    background: url('assets/site-bg.jpg') no-repeat;
    background-size: cover;
    height: 100%;
    min-height: 100%;      
  }
}

.container{
  width: 100%;
  max-width: @container;
  margin: 0 auto;
}
</style>
